import { render, staticRenderFns } from "./scheduleOnOff.vue?vue&type=template&id=b995206e&scoped=true"
import script from "./scheduleOnOff.vue?vue&type=script&lang=js"
export * from "./scheduleOnOff.vue?vue&type=script&lang=js"
import style0 from "./scheduleOnOff.vue?vue&type=style&index=0&id=b995206e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b995206e",
  null
  
)

export default component.exports